// Central, deploy-time configurable site metadata.
// When deploying on your own server/domain, set REACT_APP_SITE_URL in frontend/.env
// (e.g. https://knowledge.compubrain.com) and edit the org details below.

import { SITE_URL } from "./api";

export const siteConfig = {
  // Canonical public origin (no trailing slash). Falls back to backend URL in preview.
  siteUrl: SITE_URL,

  siteName: "CompuBrain Knowledge Base",
  author: "CompuBrain",
  parentCompanyUrl: "https://compubrain.com",

  // Contact / entity details (edit for production)
  contact: "info@compubrain.com",
  email: "info@compubrain.com",
  phone: "", // e.g. "+91 79 4003 4004" — leave empty to omit the tag

  // Social
  twitterHandle: "@compubrain",

  // Default Open Graph image (absolute URL)
  ogImage:
    "https://static.prod-images.emergentagent.com/jobs/ee9ce6fc-0ae0-4159-821e-debdcaf606bf/images/249a87a5d0e5f82af2c8918bef377e6d9ddee7119cb2cdaf16a9ee38e99f1788.jpeg",

  // GEO targeting
  geoPlacenames: ["Ahmedabad, India", "Gujarat, India"],
  geoRegion: "IN-GJ",

  // Global directives
  distribution: "Global",
  rating: "General",
  revisitAfter: "1 days",
  robots: "index, follow",
};
